WiseMetering.Views.ShowShopperTrakConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/shopper_trak/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    // edit: function() {
    //     new WiseMetering.Views.EditShopperTrakConfiguration({ model: this.model });
    // },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site()
        };
    }
});
